
import { format } from "date-fns";
import { TimeEntry } from "@/types/time-entry";
import { formatDuration } from "@/utils/formatDuration";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export interface EnhancedTimeEntry extends TimeEntry {
  user_full_name?: string;
  hourly_rate?: number;
}

interface TimeEntriesTableProps {
  timeEntries: EnhancedTimeEntry[];
}

export function TimeEntriesTable({ timeEntries }: TimeEntriesTableProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Datum</TableHead>
          <TableHead>Zeit</TableHead>
          <TableHead>Dauer</TableHead>
          <TableHead>Beschreibung</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {timeEntries.map((entry) => (
          <TableRow key={entry.id}>
            <TableCell>
              {format(new Date(entry.start_time), "dd.MM.yyyy")}
            </TableCell>
            <TableCell>
              {format(new Date(entry.start_time), "HH:mm")} –{" "}
              {entry.end_time
                ? format(new Date(entry.end_time), "HH:mm")
                : "Laufend"}
            </TableCell>
            <TableCell>
              {entry.duration ? formatDuration(entry.duration) : "-"}
            </TableCell>
            <TableCell>{entry.description || "-"}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
